import { useDialpadManagerClient } from '@frontend/dialpad';
import { ActionBarBoundary, ErrorBoundary } from '@frontend/error-boundary';
import { useHasPhoneSystemAccess } from '@frontend/phone-config';
import { useWindowWidth } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { DialpadWrap } from '../../../dialpad-wrap';
import { SoftphoneWrap } from '../../../softphone-wrap';

export const Dialpad = () => {
  const isSoftphoneDeviceConnected = useDialpadManagerClient((ctx) => ctx?.isSoftphoneDeviceConnected);

  const windowWidth = useWindowWidth({ tolerance: 5 });
  const allowSoftphoneTrayViewInTopBar = windowWidth > 850;
  if (isSoftphoneDeviceConnected) {
    return (
      <SoftphoneWrap
        allowTrayView={allowSoftphoneTrayViewInTopBar}
        allowButtonView={true}
        allowPopout={allowSoftphoneTrayViewInTopBar}
      />
    );
  }
  return <DialpadWrap />;
};

export const DialpadWrapper = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const hasPhoneSystemAccess = useHasPhoneSystemAccess({ locationIds: selectedLocationIds });

  return (
    <ErrorBoundary tier='feature' feature='dialpad' team='fe-phones' fallback={ActionBarBoundary}>
      {hasPhoneSystemAccess && <Dialpad />}
    </ErrorBoundary>
  );
};
